import { Component, OnInit } from '@angular/core';
import { MasterService,AttendanceService,AppraisalService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-hestragplan',
  templateUrl: './hestragplan.component.html',
  styleUrls: ['./hestragplan.component.scss'],
    providers:[MasterService,AttendanceService,AppraisalService]
})
export class HestragplanComponent implements OnInit {

  sections:any=[];
           classes:any=[];
           fmodel:any={};
           attdata:any=[];
           arrcourse:any=[];
           arrstaff:any=[];
           oprtype:any='';
           tabledata: any = {};
           strattmarked="";
           showload:any="no";
           showsms:any="no";
         
          arrrating=[{id:'Satisfactory',val:'Satisfactory'},{id:'Good',val:'Good'},{id:'Very Good',val:'Very Good'},{id:'Excellent',val:'Excellent'}];
           closeResult: string;
           modalOptions:NgbModalOptions;
           smmodalOptions:NgbModalOptions;
           private modalRef: NgbModalRef;
           private smallmodalRef: NgbModalRef;
         arrquestions: any;
  arrobjanexa: any=[];
  arranexa: any=[];
  rid: any='0';
  arrobjanexb: any=[];
  arranexb: any=[];
  arrobjanexd: any=[];
  arranexd: any=[];

   arrobjanexe: any=[];
  arranexe: any=[];
arrobjanexf: any=[];
  arranexf: any=[];
  arrobjanexc: any=[{actnm:'Industry Institution Collaboration' , outcome:'' , yrnm:'' ,rdid:'0'  },
    {actnm:'Library Committee member' , outcome:'' , yrnm:'' ,rdid:'0'  },
    {actnm:'Time table' , outcome:'' , yrnm:'' ,rdid:'0'  },
    {actnm:'Workload' , outcome:'' , yrnm:'' ,rdid:'0'  },
    {actnm:'Examination in-charge' , outcome:'' , yrnm:'' ,rdid:'0'  },
    {actnm:'Value added program coordinator' , outcome:'' , yrnm:'' ,rdid:'0'  },
    {actnm:'Sports Committee' , outcome:'' , yrnm:'' ,rdid:'0'  },
    {actnm:'Placement Coordinator' , outcome:'' , yrnm:'' ,rdid:'0'  }
  ];
  arranexc: any=[];
  enblc: boolean;
           constructor(private http: HttpClient,private apservice:AppraisalService,private aservice:AttendanceService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }
         
           ngOnInit(): void {
            this.getquestions(1);
            //  this.getstaff();
             //this.massection();
            //  this.fmodel.attdt=this.mservice.getdatetoday();
           }
         
              setfeedback(j,k,l,m,val)
         {
      debugger
         // alert(j);
         this.arrquestions[j].group2[k].questions[m].aprqtres=val;
         console.log('clicked',this.arrquestions);
      
         }
       

          printform(residh){
             debugger;
               var clcd=localStorage.getItem('clcd');
               var aycd=localStorage.getItem('aycd');
               var masclid=localStorage.getItem('masclid');
               var usid=localStorage.getItem('usid');
                var url=this.aservice.callurl+"fpdf181/pdfreports/aprstrpln_he.php?"+clcd+"&aycd="+aycd+"&ayid="+aycd+"&residh="+residh+"&emid="+usid+"&aprfmid=1&masclid="+masclid;
                window.open(url,'','');
              }
           getstaff() {
             this.mservice.staffrolewise()
                 .subscribe(
                 resultArray => {
                     console.log('getdashcounts', resultArray);
                     //resultArray.unshift({emid:"0",emnm:"ALL"});
                  //  resultArray.shift();
                     this.arrstaff = resultArray;
                    
                     this.fmodel.emid=resultArray[0].emid;
                     // this.amodel.emid=resultArray[0].emid;
                     // this.SelectAttdcorDetails();
                    //  this.getquestions(5,1,this.fmodel.emid);
                 },
                 error => console.log("Error :: " + error)
                 )
           }
       
       
            getquestions(plnid) {
             this.apservice.selhrtaprstrpln(plnid)
                 .subscribe(
                 resultArray => {
                     console.log('getdashcounts', resultArray);
                     
                     this.arrquestions = resultArray;
                     if(resultArray.length > 0) {
                           this.rid = resultArray[0].rid;
                       }
                     
                 },
                 error => console.log("Error :: " + error)
                 )
           }
       
           
       
         
          
         
           masclass() {
             this.mservice.masclass()
                 .subscribe(
                 resultArray => {
                     console.log('getdashcounts', resultArray);
                     this.classes = resultArray;
                     this.fmodel.clid=resultArray[0].clid;
                     //this.fmodel1.clid=resultArray[0].clid;
                     this.massection();
                   //  this.masperiod();
                    // this.mascourse();
                    
                 },
                 error => console.log("Error :: " + error)
                 )
           }
         
          
         
           mascourse() {
             this.mservice.mascourse()
                 .subscribe(
                 resultArray => {
                     console.log('getdashcounts', resultArray);
                     this.arrcourse = resultArray;
                     this.fmodel.crid=resultArray[0].crid;
                     this.masclass();
                     //this.fmodel1.crid=resultArray[0].crid;
                 },
                 error => console.log("Error :: " + error)
                 )
           }
         
           // massection() {
           //   this.mservice.massection()
           //       .subscribe(
           //       resultArray => {
           //           console.log('getdashcounts', resultArray);
           //           this.sections = resultArray;
           //           this.fmodel.secid=resultArray[0].scid;
           //       },
           //       error => console.log("Error :: " + error)
           //       )
           // }
         
           massection() {
             this.mservice.massection()
                 .subscribe(
                 resultArray => {
                     console.log('getdashcounts', resultArray);
                     this.sections = resultArray;
                     this.fmodel.secid=resultArray[0].scid;
                    // this.SelectAttdDetails();
                   //  this.getevlrooms();
                     // this.fmodel1.scid=resultArray[0].scid;
                     // this.subjects(this.fmodel.clid,this.fmodel.crid);
                 },
                 error => console.log("Error :: " + error)
                 )
           }
         
           printqrlabelsbulk(obj){
             debugger;
               var clcd=localStorage.getItem('clcd');
               var aycd=localStorage.getItem('aycd');
                var url=this.aservice.callurl+"qrcode/2Upevlstubar.php?clcd="+clcd+"&aycd="+aycd+"&clid="+obj.clid+"&scid="+obj.secid+"&crid="+obj.crid+"&rmid="+obj.rmid;
                window.open(url,'','_blank');
              }
         
              openqrdl(content)
         {
           // this.objqrprint.bkid=bkid;
           // this.objqrprint.nobc=1;
           this.fmodel.qrdoctype='2Upevlstubar';
         
         
           this.modalRef=this.modalService.open(content,this.smmodalOptions);
           
           this.modalRef.result.then((result) => {
          
                // this.Asmtdetls(asid);
                 this.closeResult = `Closed with: ${result}`;
             }, (reason) => {
                 // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
             });
         }
         
              printqrlabels(obj){
               debugger;
                 var clcd=localStorage.getItem('clcd');
                 var aycd=localStorage.getItem('aycd');
                  var url=this.aservice.callurl+"qrcode/"+obj.qrdoctype+".php?clcd="+clcd+"&aycd="+aycd+"&clid="+obj.clid+"&scid="+obj.secid+"&crid="+obj.crid+"&rmid="+obj.rmid;
                  window.open(url,'','');
                }
           
              expbarlist(obj){
               debugger;
                 var clcd=localStorage.getItem('clcd');
                 var aycd=localStorage.getItem('aycd');
                  var url=this.aservice.callurl+"export/expcsv_roomallot.php?clcd="+clcd+"&aycd="+aycd+"&clid="+obj.clid+"&scid="+obj.secid+"&crid="+obj.crid+"&rmid="+obj.rmid;
                  window.open(url,'');
                }
             
           SelectAttdDetails() {
             debugger
             var clid = this.fmodel.clid;
             var crid = this.fmodel.crid;
             var secid = this.fmodel.secid;
             var rmid = this.fmodel.rmid;
             let clcd=localStorage.getItem('clcd');
             let aycd=localStorage.getItem('aycd');
             
             var asgnmtdata = { clid: clid, clcd:clcd,aycd:aycd,crid:crid,rmid:rmid };
             console.log('model-by', asgnmtdata);
             this.aservice.getroomallocationdata(asgnmtdata)
                 .subscribe(resultArray => {
                     console.log('ret-by-atd', resultArray);
         //alert(resultArray.length);
                  
                    resultArray.forEach(x => x.status = x.status === 'true');
                    this.attdata=resultArray;
                 }, error =>
                     alert('error in connection')
                 );
         }
         
         // Savedetails()
         // {
         
         //   console.log('savearr',this.attdata);
         // }
         
         
         
         SelectAttdDtlsifnotavail() {
             debugger
             var clid = this.fmodel.clid;
             var crid = this.fmodel.crid;
             var secid = this.fmodel.secid;
             var attdt = this.fmodel.attdt;
             let clcd=localStorage.getItem('clcd');
             let aycd=localStorage.getItem('aycd');
             
             var asgnmtdata = { clid: clid, secid: secid, attdt: attdt,oprtype:'selstuses',clcd:clcd,aycd:aycd,crid:crid};
             console.log('model-by', asgnmtdata);
             this.aservice.by_sp_clmattendance(asgnmtdata)
                 .subscribe(resultArray => {
                     console.log('ret-by-atd', resultArray);
                     this.attdata = resultArray;
         
                     //alert(resultArray.message);
         
                 }, error =>
                     alert('error in connection')
                 );
         }
         
         
          saveappraisalsem()
     {
   var feedarr=[];
   var tag=true;

     outerloop:for(let j=0;j<this.arrquestions.length;j++)
               {
         
                 for (let k=0;k<this.arrquestions[j].group2.length;k++)
                 {
                  //  for(let l=0;l<this.arrquestions[j].group2[k].group3.length;l++)
                  //  {
                 for(let i=0;i<this.arrquestions[j].group2[k].questions.length;i++)
                 {
                 let objitm:any={};
                 
                   objitm.rdid=this.arrquestions[j].group2[k].questions[i].rdid;
                 objitm.pryr1=this.arrquestions[j].group2[k].questions[i].pryr1.trim();
                 objitm.pryr2=this.arrquestions[j].group2[k].questions[i].pryr2.trim();
                 objitm.cryr1=this.arrquestions[j].group2[k].questions[i].cryr1.trim();
                 objitm.cryr2=this.arrquestions[j].group2[k].questions[i].cryr2.trim();
                    objitm.cryr3=this.arrquestions[j].group2[k].questions[i].cryr3.trim();
                 console.log('objitm',objitm);
                 feedarr.push(objitm);
                 
                 }
              //  }
               }
               }
       
         if(tag)
         { 

        
         var pst={loopdata:feedarr};
    
     this.apservice.savehrstgyplan(pst)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
               this.getquestions(1);
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }


    addanexa()
{
  
  // console.log('arrvoc',this.arrvocdet);
  // this.getacchead1();
this.arrobjanexa.push({rdid:'0',protitle:'' , orgnm:'',sanamt:'' , yrnm:''  });
console.log('arrvoc1',this.arrobjanexa);

}

remanexa(index)
{
  
  this.arrobjanexa.splice(index, 1);
         if (this.arrobjanexa.length === 0) {
             this.arrobjanexa = [];
         }

}



 selhrtaprstr_annexa(plnid) {
               this.apservice.selhrtaprstr_annexa(plnid)
                   .subscribe(
                   resultArray => {
                       console.log('getdashcounts', resultArray);
                       
                       this.arranexa = resultArray;
                      
                       
                   },
                   error => console.log("Error :: " + error)
                   )
             }

    savehrtaprstr_annexa(obj,oprtype)
     {
      debugger;
  //  var feedarr=[];
  obj.oprtype=oprtype;
  obj.rid=this.rid;
   var tag=true;
  
         if(tag)
         { 

       
        //  var pst={aprqtid:this.objhdnvalue.pubaprqtid,residh:this.objhdnvalue.pubresidh,residd:this.objhdnvalue.pubresidd,loopdata:this.arrobjpub};
    
     this.apservice.savehrtaprstr_annexa(obj)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                this.selhrtaprstr_annexa(this.rid);
                if(oprtype=='i')
                {
                this.arrobjanexa=[];
                }
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }
      
      addanexb()
{
  
  // console.log('arrvoc',this.arrvocdet);
  // this.getacchead1();
this.arrobjanexb.push({rdid:'0',actnm:'' , outcome:'' , yrnm:''  });
console.log('arrvoc1',this.arrobjanexb);

}

remanexb(index)
{
  
  this.arrobjanexb.splice(index, 1);
         if (this.arrobjanexb.length === 0) {
             this.arrobjanexb = [];
         }

}



 selhrtaprstr_annexb(plnid) {
               this.apservice.selhrtaprstr_annexb(plnid)
                   .subscribe(
                   resultArray => {
                       console.log('getdashcounts', resultArray);
                       
                       this.arranexb = resultArray;
                      
                       
                   },
                   error => console.log("Error :: " + error)
                   )
             }

    savehrtaprstr_annexb(obj,oprtype)
     {
      debugger;
  //  var feedarr=[];
  obj.oprtype=oprtype;
  obj.rid=this.rid;
   var tag=true;
  
         if(tag)
         { 

       
        //  var pst={aprqtid:this.objhdnvalue.pubaprqtid,residh:this.objhdnvalue.pubresidh,residd:this.objhdnvalue.pubresidd,loopdata:this.arrobjpub};
    
     this.apservice.savehrtaprstr_annexb(obj)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                this.selhrtaprstr_annexb(this.rid);
                if(oprtype=='i')
                {
                this.arrobjanexb=[];
                }
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }


    addanexd()
{
  
  // console.log('arrvoc',this.arrvocdet);
  // this.getacchead1();
this.arrobjanexd.push({rdid:'0',coursehandle:'' , strength:'' , avatt:'',noofclass:'',avres:'',coattainment:''  });
console.log('arrvoc1',this.arrobjanexd);

}

remanexd(index)
{
  
  this.arrobjanexd.splice(index, 1);
         if (this.arrobjanexd.length === 0) {
             this.arrobjanexd = [];
         }

}


 selhrtaprstr_annexd(plnid) {
               this.apservice.selhrtaprstr_annexd(plnid)
                   .subscribe(
                   resultArray => {
                       console.log('getdashcounts', resultArray);
                       
                       this.arranexd = resultArray;
                      
                       
                   },
                   error => console.log("Error :: " + error)
                   )
             }
 savehrtaprstr_annexd(obj,oprtype)
     {
      debugger;
  //  var feedarr=[];
  obj.oprtype=oprtype;
  obj.rid=this.rid;
   var tag=true;
  
         if(tag)
         { 

       
        //  var pst={aprqtid:this.objhdnvalue.pubaprqtid,residh:this.objhdnvalue.pubresidh,residd:this.objhdnvalue.pubresidd,loopdata:this.arrobjpub};
    
     this.apservice.savehrtaprstr_annexd(obj)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                this.selhrtaprstr_annexd(this.rid);
                if(oprtype=='i')
                {
                this.arrobjanexd=[];
                }
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }

   
    addanexe()
{
  
  // console.log('arrvoc',this.arrvocdet);
  // this.getacchead1();
this.arrobjanexe.push({rdid:'0',protitle:'' , stuno:'' , outcome:'',poattainment:''});
console.log('arrvoc1',this.arrobjanexe);

}

remanexe(index)
{
  
  this.arrobjanexe.splice(index, 1);
         if (this.arrobjanexe.length === 0) {
             this.arrobjanexe = [];
         }

}


 selhrtaprstr_annexe(plnid) {
               this.apservice.selhrtaprstr_annexe(plnid)
                   .subscribe(
                   resultArray => {
                       console.log('getdashcounts', resultArray);
                       
                       this.arranexe = resultArray;
                      
                       
                   },
                   error => console.log("Error :: " + error)
                   )
             }
 savehrtaprstr_annexe(obj,oprtype)
     {
      debugger;
  //  var feedarr=[];
  obj.oprtype=oprtype;
  obj.rid=this.rid;
   var tag=true;
  
         if(tag)
         { 

       
        //  var pst={aprqtid:this.objhdnvalue.pubaprqtid,residh:this.objhdnvalue.pubresidh,residd:this.objhdnvalue.pubresidd,loopdata:this.arrobjpub};
    
     this.apservice.savehrtaprstr_annexe(obj)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                this.selhrtaprstr_annexe(this.rid);
                if(oprtype=='i')
                {
                this.arrobjanexe=[];
                }
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }

 selhrtaprstr_annexc(plnid) {
               this.apservice.selhrtaprstr_annexc(plnid)
                   .subscribe(
                   resultArray => {
                       console.log('getdashcounts', resultArray);
                       
                       this.arranexc = resultArray;
                       if (resultArray) {
                        this.enblc = true;
                       }
                      else
                      {
                        this.enblc = false;
                      }
                       
                   },
                   error => console.log("Error :: " + error)
                   )
             }

              savehrtaprstr_annexc(obj,oprtype)
     {
      debugger;
  //  var feedarr=[];
  var pst={loopdata:obj,oprtype:oprtype,rid:this.rid};
  // obj.oprtype=oprtype;
  // obj.rid=this.rid;
  console.log('pst',pst);
   var tag=true;
  
         if(tag)
         { 

       
        //  var pst={aprqtid:this.objhdnvalue.pubaprqtid,residh:this.objhdnvalue.pubresidh,residd:this.objhdnvalue.pubresidd,loopdata:this.arrobjpub};
    
     this.apservice.savehrtaprstr_annexc(pst)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                this.selhrtaprstr_annexc(this.rid);
                
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }



    addanexf()
{
  
  // console.log('arrvoc',this.arrvocdet);
  // this.getacchead1();
this.arrobjanexf.push({rdid:'0',title:'' , author:'' , pubdate:'',source:''});
console.log('arrvoc1',this.arrobjanexf);

}

remanexf(index)
{
  
  this.arrobjanexf.splice(index, 1);
         if (this.arrobjanexf.length === 0) {
             this.arrobjanexf = [];
         }

}


 selhrtaprstr_annexf(plnid) {
               this.apservice.selhrtaprstr_annexf(plnid)
                   .subscribe(
                   resultArray => {
                       console.log('getdashcounts', resultArray);
                       
                       this.arranexf = resultArray;
                      
                       
                   },
                   error => console.log("Error :: " + error)
                   )
             }
 savehrtaprstr_annexf(obj,oprtype)
     {
      debugger;
  //  var feedarr=[];
  obj.oprtype=oprtype;
  obj.rid=this.rid;
   var tag=true;
  
         if(tag)
         { 

       
        //  var pst={aprqtid:this.objhdnvalue.pubaprqtid,residh:this.objhdnvalue.pubresidh,residd:this.objhdnvalue.pubresidd,loopdata:this.arrobjpub};
    
     this.apservice.savehrtaprstr_annexf(obj)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                this.selhrtaprstr_annexf(this.rid);
                if(oprtype=='i')
                {
                this.arrobjanexf=[];
                }
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }

         }
         
       
    
  
